import React from "react";
import cmoBg from "../Images/cmobackground.jpg";
import "../CampaignComponent/CampaginComponentCss/CMOHero.css";

export default function CMOHero() {
  return (
    <section
      className="cmo-hero-section"
      style={{ backgroundImage: `url(${cmoBg})` }}
    >
      <div className="cmo-hero-overlay"></div>

      <div className="cmo-hero-content">
        <h1 className="cmo-title">मुख्यमंत्री अभियान</h1>

        <p className="cmo-subtext">
          ग्रामविकास, स्वच्छता, पायाभूत सुविधा आणि ग्रामस्थ कल्याण यांसाठी
          राबविण्यात येणारे राज्यस्तरीय अभियान. या उपक्रमांतून प्रत्येक गाव
          आत्मनिर्भर आणि समृद्ध बनविण्याचा प्रयत्न केला जातो.
        </p>
      </div>
    </section>
  );
}
